module.exports = __webpack_public_path__ + "img/sparkles.ec9e2a3.svg";